<section *ngIf="hasNumber" class="uc-stamp" role="region" [attr.aria-label]="'unifiedShell.stamp.ariaLabel' | translate">
  <div class="uc-stamp__inner">
    <div class="uc-stamp__main">
      <span class="uc-stamp__flag" aria-hidden="true"></span>
      <p class="uc-stamp__statement mb-0">{{ 'unifiedShell.stamp.statement' | translate }}</p>
      <p class="uc-stamp__registration mb-0">
        <span>{{ 'unifiedShell.stamp.registeredWith' | translate }}</span>
        <a *ngIf="hasCertificateUrl; else plainNumber" class="uc-stamp__number" [href]="certificateUrl" target="_blank" data-uc-external-icon
          rel="noopener noreferrer">
          <bdi>{{ registrationNumber }}</bdi>
          <i class="fa-solid fa-arrow-up-right-from-square uc-external-icon" aria-hidden="true"></i>
        </a>
        <ng-template #plainNumber><bdi class="uc-stamp__number">{{ registrationNumber }}</bdi></ng-template>
      </p>
    </div>
    <!-- Secondary elements slot: at most TWO elements may be projected here (criterion 11, row 46). Left empty by default. -->
    <div class="uc-stamp__secondary">
      <ng-content></ng-content>
    </div>
  </div>
</section>
